<template>
    <div class="o-layout o-layout--center">
        <div class="c-panel">

            <template v-if="!this.enabled">
                <h2 class="margin-b-8">Scan de code</h2>
                <p>Open de app Google Authenticator op je telefoon of tablet en scan de onderstaande QR-Code</p>

                <template v-if="isSVG">
                    <p v-html="qrcode"></p>
                </template>
                <template v-else>
                    <p><img :src="qrcode"/></p>
                </template>
                
            </template>
            <template v-else>
                <h2 class="margin-b-8">Voer je verificatiecode in</h2>
            </template>

            <p>Vul hieronder de verificatiecode in die wordt weergeven in de app.</p>

            <button v-if="user.allow_sms_2fa" class="c-btn c-btn--expanded margin-t-32 no-margin-b" @click="sendSms" :disabled="processingSms">Stuur de code via SMS</button>
            <p class="color-alert" v-if="errorSms">SMS is niet verstuurd, mogelijk is deze optie niet beschikbaar voor uw account of uw telefoonnummer is niet bekend.</p>
            <p class="color-success" v-if="successSms">SMS is verstuurd, vul de code hieronder in.</p>

            <c-form ref="form" @valid="submit" :autocomplete="'off'">
                <c-form-element
                    :label="'Verificatiecode'">
                    <input type="text" v-model="secret" data-pattern="[\d]{6}" required name="secret" autocomplete="register_verification_code" />
                </c-form-element>
                
                <p class="color-alert" v-if="error">Verificatiecode is niet correct of is verlopen.</p>

                <button class="c-btn c-btn--expanded margin-t-32 no-margin-b" :disabled="processing">Versturen</button>
            </c-form>

        </div>
    </div>
</template>

<script>
    import Form from '@mixins/Form';
    import { mapState } from 'vuex';

    export default {
        mixins: [ Form ],
        data() {
            return {
                secret: '',
                enabled: true,
                qrcode: null,
                processing: false,
                processingSms: false,
                error: false,
                errorSms: false,
                successSms: false,
            }
        },
        methods: {
            submit() {

                this.processing = true;
                this.error = false;

                if ( this.enabled ) {

                     this.$xhr.post('/api/auth/google2fa/verify/', {otp_secret: this.secret}).then( ({result}) => {
                         this.$router.push({path: '/'});
                         this.processing = false;
                     }).catch( () => {
                         this.processing = false;
                         this.error = true;
                     });
                }
                else {
                    this.$xhr.post('/api/auth/google2fa/enable/', {otp_secret: this.secret}).then( () => {
                        this.$router.push({path: '/'});
                        this.processing = false;
                     }).catch( () => {
                         this.processing = false;
                         this.error = true;
                     });
                }
            },
            sendSms() {
                this.processingSms = true;
                this.errorSms = false;
                this.successSms = false;
                this.$xhr.post('/api/auth/google2fa/sms/')
                    .then(() => this.successSms = true)
                    .catch(() => this.errorSms = true)
                    .finally(() => {
                        setTimeout(() => this.processingSms = false, 10000)
                    });
            }
        },
        computed: {
            isSVG() {
                return this.qrcode.indexOf('<?xml') === 0;
            },
            ...mapState({
                user: state => state.user.data,
            }),
        },
        created() {

             this.$xhr.get('/api/auth/google2fa/qrcode/').then( ({result}) => {
                if ( result && result.qrcode ) {
                    this.enabled = false;
                    this.qrcode = result.qrcode;
                }
            }).catch((e) => { console.error('Google 2fa', e) });
        }
    }
</script>